module.exports = __webpack_public_path__ + "static/media/carved.dabf1ee5.jpeg";